import {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core';
import {useDispatch, useSelector} from "react-redux";
import {moveNextPage, updateCreatorOnboarding} from "../../../../store/actions/creator/creatorOnBoarding";
import UtilService from "../../../../helper/service";
import {useHistory, useLocation} from "react-router";
import OnboardingBtn from "../../../atoms/creator/onboardingEnterBtn";

const useStyles = makeStyles((theme) => ({
  mainTitle: {
    fontSize: (props: any) => props.width < 1420 ? 36 : 40,
    fontFamily: 'Spartan-bold',
    color: '#212D40',
    textAlign: 'center',
    marginTop: 10,
    marginBottom: 20
  },
  title: {
    fontSize: (props: any) => props.height < 770 ? 20 : 24,
    color: '#212D40',
    fontFamily: 'roboto-light',
    lineHeight: 1.25,
    '@media (max-width: 1400px)': {
      fontSize: 22,
    },
    '@media (max-width: 600px)': {
      fontSize: '16px!important',
    },
  },
  img: {
    borderRadius: 32,
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    height: 'auto',
    '@media (max-width: 600px)': {
      width: 260,
    },
  },
  checkerImg: {
    width: 60,
    height: 60,
    marginBottom: 10
  },
  checkerDiv: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    fontFamily: 'roboto-bold',
    fontSize: 14,
    color: '#212D40',
    alignItems: 'center',
    lineHeight: 1.25
  },
  descriptionDiv: {
    display: 'flex',
    marginBottom: (props: any) => props.height < 770 ? -40 : -30,
    marginTop: 20,
    '@media (max-width: 600px)': {
      flexDirection: 'column'
    },
  },
  optionDiv: {
    display: 'flex',
    margin: (props: any) => props.height < 770 ? '50px 0' : '30px 0'
  }
}));

function OnBoardingStart() {
  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
  const firstName = localStorage.getItem('firstName') ? localStorage.getItem('firstName') : '';
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { is_loaded, userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [name, setName] = useState('');

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      is_loaded && goNext();
    }
  };

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'start');
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    if (firstName) {
      setName(firstName);
    } else {
      setName(loginUserData.first_name)
    }
  }, [firstName, loginUserData]);

  const goNext = () => {
    if (Number(activepage.value) < 2) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '2',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));
    }

    is_loaded && dispatch(moveNextPage(2))
  };

  const goBack = () => {
    dispatch(moveNextPage(0))
  };

  return (
    <>
      <div className={classes.mainTitle}>
        Hi{name && ','} {UtilService.capitalizeFirstLetter(name)}{name && '!'}
      </div>

      <div className={classes.title}>
        Can you imagine a world where you knew how content would perform BEFORE it was released?
      </div>

      <div className={classes.descriptionDiv}>
        <div style={{ flex: 1 }}>
          <p className={classes.title}>
            Becoming a mind-reading badass requires 10 minutes & completing 4 super-quick modules.
          </p>
          <div className={classes.optionDiv}>
            <div className={classes.checkerDiv}>
              <img src="/assets/icons/onboarding/onboarding-start-check.svg" alt="checker" className={classes.checkerImg} />
              <span>Learn</span>
              <span>How it Works</span>
            </div>
            <div className={classes.checkerDiv}>
              <img src="/assets/icons/onboarding/onboarding-start-check.svg" alt="checker" className={classes.checkerImg} />
              <span>Measure</span>
              <span>a Video</span>
            </div>
            <div className={classes.checkerDiv}>
              <img src="/assets/icons/onboarding/onboarding-start-check.svg" alt="checker" className={classes.checkerImg} />
              <span>Schedule a</span>
              <span>Data Debrief</span>
            </div>
            <div className={classes.checkerDiv}>
              <img src="/assets/icons/onboarding/onboarding-start-check.svg" alt="checker" className={classes.checkerImg} />
              <span>Review</span>
              <span>Results</span>
            </div>
          </div>
          <p className={classes.title}>
            So, over the next 10 minutes, we’ll show you everything you need to know to make audience insight your own personal super power.
          </p>
          <p className={classes.title}>
            Ready?
          </p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1 }}>
          <img src="/assets/icons/onboarding/onboarding-start.svg" alt="avatar" className={classes.img} />
        </div>
      </div>
      <OnboardingBtn
        goBack={goBack}
        goNext={goNext}
        hiddenBack
        title={'Let’s Go!'}
      />
    </>
  )
}

export default OnBoardingStart;